import { normalizeObject, dataLayerPush } from "../shared/utils";
// Search Initiated Event Handler
var productListViewHandler = function (e) {
    var dataLayerEventData = {
        non_interaction: false,
        standard_interactions: 0,
        std_pdp_view: 0,
        std_plp_view: 0,
    };
    var productListDetails = normalizeObject(e === null || e === void 0 ? void 0 : e.detail) || {};
    var productList = [];
    Object.values(productListDetails["product_list"]).forEach(function (productListItem, i) {
        productList.push({
            item_brand: productListDetails["product_list_type"],
            item_list_name: productListDetails["product_list_name"],
            item_category: productListItem["category"],
            item_id: productListItem["id"],
            item_name: productListItem["name"],
            item_variant: productListItem["variant"] + ":" + productListItem["price"],
            price: productListItem["price"],
            product_position: i,
        });
    });
    Object.assign(dataLayerEventData, normalizeObject({
        event: "view_item_list",
        event_action: "product_impression",
        event_category: "ecommerce",
        event_label: document.title,
        ecommerce: {
            items: productList
        },
        non_interaction: true,
        standard_interactions: 1,
        std_plp_view: 1,
    }));
    dataLayerPush({ ecommerce: null });
    dataLayerPush(dataLayerEventData);
};
var productListItemClickHandler = function (e) {
    var dataLayerEventData = {
        non_interaction: false,
        standard_interactions: 0,
        std_pdp_view: 0,
        std_plp_view: 0,
    };
    var productListItemDetails = normalizeObject(e === null || e === void 0 ? void 0 : e.detail) || {};
    Object.assign(dataLayerEventData, normalizeObject({
        event: "select_item",
        event_action: "product_click",
        event_category: "ecommerce",
        event_label: productListItemDetails["name"],
        ecommerce: {
            items: [{
                    item_brand: "gift_catalog",
                    item_category: productListItemDetails["category"],
                    item_list_name: document.title,
                    item_id: productListItemDetails["id"],
                    item_name: productListItemDetails["name"],
                    item_variant: productListItemDetails["variant"] + ":" + productListItemDetails["price"],
                    price: productListItemDetails["price"],
                    product_position: productListItemDetails["position"],
                }]
        }
    }));
    dataLayerPush({ ecommerce: null });
    dataLayerPush(dataLayerEventData);
};
var productViewHandler = function (e) {
    var dataLayerEventData = {
        non_interaction: false,
        standard_interactions: 0,
        std_pdp_view: 0,
    };
    var productItemDetails = normalizeObject(e === null || e === void 0 ? void 0 : e.detail) || {};
    Object.assign(dataLayerEventData, normalizeObject({
        event: "view_item",
        event_action: "product_detail_view",
        event_category: "ecommerce",
        event_label: productItemDetails["name"],
        ecommerce: {
            items: [{
                    item_brand: "gift_catalog",
                    item_category: productItemDetails["category"],
                    item_id: productItemDetails["id"],
                    item_name: productItemDetails["name"],
                    item_variant: productItemDetails["variant"] + ":" + productItemDetails["price"],
                    price: productItemDetails["price"],
                }]
        },
        non_interaction: true,
        standard_interactions: 1,
        std_pdp_view: 1
    }));
    dataLayerPush({ ecommerce: null });
    dataLayerPush(dataLayerEventData);
};
var productAddToCartHandler = function (e) {
    var dataLayerEventData = {
        non_interaction: false,
        standard_interactions: 0,
        std_pdp_view: 0,
    };
    var productItemDetails = normalizeObject(e === null || e === void 0 ? void 0 : e.detail) || {};
    Object.assign(dataLayerEventData, normalizeObject({
        event: "add_to_cart",
        event_action: "add_to_cart",
        event_category: "ecommerce",
        event_label: productItemDetails["name"],
        ecommerce: {
            items: [{
                    item_brand: "gift_catalog",
                    item_category: productItemDetails["category"],
                    item_id: productItemDetails["id"],
                    item_name: productItemDetails["name"],
                    item_variant: productItemDetails["variant"] + ":" + productItemDetails["price"],
                    price: productItemDetails["price"],
                    quantity: productItemDetails["quantity"],
                }]
        },
        hi_add_to_carts: 1,
        high_intent_interactions: 1
    }));
    dataLayerPush({ ecommerce: null });
    dataLayerPush(dataLayerEventData);
};
export { productListViewHandler, productListItemClickHandler, productViewHandler, productAddToCartHandler };
